/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

// @flow
import type { Element } from 'react';

import React from 'react';
import { FormText } from 'reactstrap';
import Tip from '#components/support/tooltips/Tip/index.jsx';

type Props = {|
  isReadOnly?: boolean,
|};

/**
 * The site location — address and coordinates — is one lock, so it gets one note. Rendered on both
 * Site Coordinates and Model and Site Info; ids are kept from the coordinate-only version so
 * existing assertions still resolve.
 */
const SiteLocationLockNote = ({ isReadOnly = false }: Props): Element<typeof FormText> =>
  isReadOnly ? (
    <FormText id="coordinatesLocked" color="muted">
      * Why is my site location locked? <Tip tipId="siteCoordinatesLocked" />
    </FormText>
  ) : (
    <FormText id="coordinatesLockWarning" color="muted">
      * Site location locks once model is run.
    </FormText>
  );

export default SiteLocationLockNote;
